import { JOURNEY_LIBRARY } from '../data/journeyLibrary.js';
import { GENERIC_JOURNEY_CONTENT } from '../data/genericJourneyContent.js';
import { effectiveTranslation } from './effectiveTranslation.js';
import { sourceRevision } from './translationAssurance.js';

// Generic templates are rendered from JavaScript data, not en/hospitalJourney.json.
// Expose their English source with the same namespace/key used by the runtime
// narrative overlay. The approved-translation layer can then publish corrections.
export function buildGenericJourneyTranslationRows(locale) {
  const rows = [];
  function add(journeyId, path, sourceText) {
    if (typeof sourceText !== 'string' || !sourceText.trim()) return;
    const key = 'journeys.generic-' + journeyId + '.' + path;
    const id = 'hospitalJourney:' + key;
    const translated = effectiveTranslation(locale, 'hospitalJourney', key, '');
    rows.push({ id, namespace: 'hospitalJourney', path: key,
      contentArea: 'hospital_journeys', sourceText,
      sourceRevision: sourceRevision(id, sourceText), originalText: translated.value,
      provenance: translated.provenance, publicationTarget: 'locale',
      rawLocaleText: '' });
  }
  for (const template of JOURNEY_LIBRARY) {
    add(template.id, 'title', template.title);
    add(template.id, 'introduction', template.summary);
    for (const stage of template.stages || []) add(template.id, 'stages.' + stage.id + '.title', stage.title);
    const content = GENERIC_JOURNEY_CONTENT[template.id] || {};
    (content.questions || []).forEach((question, i) => add(template.id, 'questions.' + i, question));
    for (const link of content.usefulLinks || []) {
      add(template.id, 'usefulLinks.' + link.id + '.title', link.title);
      add(template.id, 'usefulLinks.' + link.id + '.description', link.description);
    }
  }
  return rows;
}
